import zaobora from '../images/zaobora.png'
import citizen from '../images/citizen.png'
import cert from '../images/cert.jpg'
import manjumu from '../images/manjumu.png'
import nextjs from '../images/nextjs.png'
import nodejs from '../images/nodejs.png'
import redux from '../images/redux.png'
import reactnative from '../images/reactnative.png'
import reactjs from '../images/reactjs.png'
import celo from '../images/celo.png'
import sdg from '../images/sdg.png'


export default [
    {
        alt: 'Citizen project',
        img: citizen,
        title: "Citizen",
        description: "Citizen is a decentralized mobile application built to tracks government money transfer to it's correct destination.",
        context: "Citizen is a project that aims to combat corruption in Kenya as well as in Africa through leveraging blockchain technologies to achieve decentralization of public procurement ledgers to eliminate one single source of truth and publicize all procurement records to promote transparency. Project Citizen speaks to goal 16 of Sustainable Development Goals which aims to achieve Peace, Justice, and Strong Institutions.",
        technologies: [sdg, celo, reactnative],
        live: null,
        certification: cert,
        github: '',
        resources: {
            gallery: [
                'Citizen-certificate-award.jpg',
                'Citizen-trophy-award.jpg',
                'UNODC-hackathon-certificate.jpg',
                'Governor-James-Nyoro-speech.jpg',
                'Governor-James-Nyoro.jpg',
                'Kiambu-Governor&UNODC-representatives.jpg',
                'UNODC-event-group-photo.jpg',
                'UNODC-event.jpg',
                'UNODC-hackathon-participants.jpg'
            ],
            videos: [

            ],
            document: ''
        },
        link: '/citizen',
        id: "citizen"
    },
    {
        alt: 'Manjumu',
        img: manjumu,
        title: "Manjumu",
        description: "A platform for selling sneakers online.",
        context: "A simple ecommerce store for selling sneakers online",
        technologies: [nextjs, redux, nodejs],
        gallery: [],
        live: 'https://brandykicks.vercel.app/',
        certification: null,
        github: 'https://github.com/Dave-mash/Brandykicks-Kenya',
        resources: null,
        link: '/manjumu',
        id: "manjumu"
    },
    {
        alt: 'ZaoBora project',
        img: zaobora,
        title: "ZaoBora",
        description: "ZaoBora is an online platform and community that directly connects farmers with potential retailers and consumers.",
        context: "ZaoBora is an online marketing and trading platform designed for farmers, wholesalers and retailers. Through this app, farmers can be able to sell their products directly to consumers, thereby eliminating the need for brokers and as a result increase profit margins. ZaoBora aims to promote sustainable agriculture as stated in sustainable development goal 2 through creating opportunities for farmers",
        technologies: [reactjs, redux, nodejs],
        gallery: [],
        live: '',
        certification: null,
        github: 'https://github.com/BuildForSDGCohort2/Team-254-zaoBora-frontend',
        resources: null,
        link: '/zaobora',
        id: "zaobora"
    }
]